import * as React from 'react';
import PropTypes from 'prop-types';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { ContextData } from '../../../../context/Context';

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%' }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" sx={{color:"white"}}>{`${Math.round(
          props.value,
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};

export default function FormLoaderStep(props) {
  const {BioProgressStatus} = React.useContext(ContextData)
  
  const [progress, setProgress] = React.useState(0);
  
  React.useEffect(() => {

    /* const timer = setInterval(() => {
    }, 800); */

    setProgress((prevProgress) => (prevProgress !== props.value ? props.value  :  0));

  /*   return () => {
      clearInterval(timer);
    }; */
    
  }, [props.value]);

  return (
    <Box sx={{ width: '100%' }}>
      <LinearProgressWithLabel value={progress} />
    </Box>
  );
}